import { Configuration } from '@azure/msal-browser';

export const msalConfig: Configuration = {
    auth: {
        clientId: "5a556b17-fb8d-4c90-be4d-d6e467d0b83c",
        authority: "https://login.microsoftonline.com/common",
        redirectUri: window.location.origin + '/auth-callback',
        // Keep auth-state on the redirect page; do not bounce back to the
        // initiating URL (this is an auth-config option, not a request option).
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: "localStorage",
        // Mirror auth state into a cookie. Required for browsers that drop or
        // partition web storage across the redirect (Edge / legacy), which is
        // what broke SSO in Edge while it worked in Chrome.
        storeAuthStateInCookie: true,
    }
};

export const loginRequest = {
    scopes: ['api://97cd06f6-c9c6-46da-8859-be54b0eda196/access_as_user'],
    prompt: "select_account"
};
